import { render, staticRenderFns } from "./share_QR_code.vue?vue&type=template&id=067e419d&scoped=true"
import script from "./share_QR_code.vue?vue&type=script&lang=js"
export * from "./share_QR_code.vue?vue&type=script&lang=js"
import style0 from "./share_QR_code.vue?vue&type=style&index=0&id=067e419d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067e419d",
  null
  
)

export default component.exports